import * as React from "react";
const SvgFiRrBellSlash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-bell-slash_svg__a)">
      <path
        fill="#062147"
        d="M16.034 21.42A4.46 4.46 0 0 1 12 24a4.45 4.45 0 0 1-4.42-4H6.051a5.02 5.02 0 0 1-3.939-1.891 5.03 5.03 0 0 1-.99-4.254l1.322-5.106a1 1 0 0 1 1.936.502l-1.314 5.07a3.02 3.02 0 0 0 .607 2.537A3.03 3.03 0 0 0 6.053 18H13a1 1 0 0 1 0 2h-3.4a2.446 2.446 0 0 0 2.4 2c.95 0 1.82-.557 2.22-1.42a1 1 0 1 1 1.814.84m7.673 2.287a.997.997 0 0 1-1.414 0l-22-22A.999.999 0 1 1 1.707.293l3.065 3.065A9.4 9.4 0 0 1 12 0a9.454 9.454 0 0 1 9.082 6.902l1.737 6.714a5.01 5.01 0 0 1-.849 4.388 5.1 5.1 0 0 1-1.329 1.222l3.066 3.066a1 1 0 0 1 0 1.414M6.194 4.78l12.971 12.97a3 3 0 0 0 1.211-.953 3.03 3.03 0 0 0 .511-2.662L19.151 7.42C18.266 4.237 15.324 2 12.001 2a7.4 7.4 0 0 0-5.806 2.78z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-bell-slash_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBellSlash;
